import { cn } from "@tellescope/ui";
import { Ref } from "react";

import { HtmlTokenField, HtmlTokenFieldHandle } from "./HtmlTokenField";
import { TemplateHtmlPreview } from "./TemplateHtmlPreview";

export interface HtmlModeViewProps {
  id?: string;
  html: string;
  onChange: (html: string) => void;
  fieldRef: Ref<HtmlTokenFieldHandle>;
  /** Controlled by the toolbar's Edit/Preview toggle. */
  showPreview: boolean;
  disabled?: boolean;
  /** When true, the field serializes links as literal `<a>` rather than `{url}[text]` markup. */
  preserveAnchorTags?: boolean;
}

/**
 * Raw HTML editing (tokens rendered as pills) or a sanitized, sandboxed preview. The preview also
 * renders tokens as badges so the user can see those values are filled in at send time. The Edit /
 * Preview toggle lives in the toolbar; this view just reflects `showPreview`.
 */
export const HtmlModeView = ({
  id,
  html,
  onChange,
  fieldRef,
  showPreview,
  disabled,
  preserveAnchorTags,
}: HtmlModeViewProps) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <TemplateHtmlPreview html={html} className={cn("min-h-48 flex-1 p-2", !showPreview && "hidden")} />
      <div className={cn("flex min-h-0 flex-1 flex-col", showPreview && "hidden")}>
        <HtmlTokenField
          id={id}
          ref={fieldRef}
          html={html}
          onChange={onChange}
          disabled={disabled}
          preserveAnchorTags={preserveAnchorTags}
        />
      </div>
    </div>
  );
};
